import FichesComponent from "../../components/FichesComponent";
import SEO from "../../components/SEO";
import { pageSEOData } from "../../data/seoData";

const FichesPage: React.FC = () => {
  const seo = pageSEOData.fiches;

  return (
    <div className="page-animation">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        ogImage={seo.ogImage}
      />
      <FichesComponent />
    </div>
  );
};

export default FichesPage;
